import { ComponentProps, FC, PropsWithChildren } from 'react';

import { Box } from '@bonusly/design-system';

interface UserSpotlightCardShellProps extends PropsWithChildren {
	/**
	 * Optional override for the inner "content" card padding (the solid surface).
	 */
	innerPadding?: ComponentProps<typeof Box>['p'];
	rounded?: boolean;
	constrainHeight?: boolean;
}

export const UserSpotlightCardShell: FC<UserSpotlightCardShellProps> = ({
	children,
	innerPadding = { base: 8, md: '60px' },
	rounded = true,
	constrainHeight = true,
}) => {
	return (
		<Box
			borderRadius={rounded ? '3xl' : 'none'}
			bg="bg.minipage"
			backdropFilter="blur(20px)"
			p="15px"
			border="1.5px solid"
			borderColor="bg.surface"
			maxH={constrainHeight ? { base: 'none', md: 'calc(100vh - 220px)' } : undefined}
			overflow="hidden"
			display="flex"
			flexDirection="column"
			sx={{
				WebkitBackdropFilter: 'blur(20px)',
				// Force light mode shadow in both modes (dark mode shadow is too strong for spotlight's bright background)
				boxShadow: '0 0 1px 0 #43485614, 0 2px 4px 0 #43485614, 0 9px 8px 0 #43485614, 0 21px 12px 0 #4348560a, 0 37px 14px 0 #43485603',
			}}
		>
			<Box
				bg="bg.surface"
				borderRadius={rounded ? '2xl' : 'none'}
				p={innerPadding}
				display="flex"
				flexDirection="column"
				justifyContent="flex-start"
				position="relative"
				flex="1"
				overflowY="auto"
				sx={{
					// Custom scrollbar styling for card content
					'&::-webkit-scrollbar': {
						width: '6px',
					},
					'&::-webkit-scrollbar-track': {
						bg: 'transparent',
					},
					'&::-webkit-scrollbar-thumb': {
						bg: 'bg.soft',
						borderRadius: 'full',
					},
				}}
			>
				{children}
			</Box>
		</Box>
	);
};
